<ng-template #closeicon>
  <app-icon (onIconClick)="closeDialog()" [icon]="'CLOSE'" [color]="'var(--bg-light)'" [title]="''" />
</ng-template>
<ng-template #endButtons>
  <div style="display: flex;">
    @if (endElement) {
    <ng-container *ngTemplateOutlet="endElement"></ng-container>
    }
    <ng-container *ngTemplateOutlet="closeicon"></ng-container>

  </div>
</ng-template>
<div class="flex justify-content-center">
  <p-dialog [focusOnShow]="false" [draggable]="false" [breakpoints]="{'960px': '75vw', '640px': '80vw', '430px': '90vw'}" (onShow)="onShow($event)"
    [closable]="false" [modal]="true" [(visible)]="visible" [maximizable]="maximizable" [style]="style"
    [dismissableMask]="true" (onHide)="closeDialog()">
    <ng-template pTemplate="header" class="d-flex w-100">
      @if (titleString) {
      <div class="card-header-text">
        {{ titleString }}
      </div>
      }
      @if(title) {
      <ng-container *ngTemplateOutlet="title"></ng-container>
      }
      <div class="ml-auto d-flex">

        <ng-container *ngTemplateOutlet="endButtons"></ng-container>


      </div>

    </ng-template>
    @if(customizeColumn) {
    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-between mt-2">
        <div>
          <button class="resetButton" (click)="resetClick && resetClick()">RESET COLUMNS</button>
        </div>
        <div style="display: flex; gap: 1rem;">
          <button class="closeButton" (click)="closeDialog()">CLOSE</button>
          <button class="applyButton" (click)="applyClick && applyClick()">APPLY</button>
        </div>
      </div>
    </ng-template>
    }
    <div *ngIf="showContent" class="h-100 ">
      <ng-content class="h-75"></ng-content>
    </div>
  </p-dialog>
</div>